export type ShortcodeSegment =
  | { type: 'markdown'; content: string }
  | { type: 'standalone-quote'; quote: string; author: string }
  | { type: 'font'; size: string; weight: string; content: string }

const STANDALONE_PATTERN = /\{\{<\s*standalone-quote\s+quote="([^"]*)"\s+author="([^"]*)"\s*>\}\}/g
const FONT_OPEN_PATTERN = /\{\{<\s*font\s+size="([^"]*)"\s+weight="([^"]*)"\s*>\}\}/

function findAllMatches(
  text: string
): Array<{ start: number; end: number; segment: ShortcodeSegment }> {
  const matches: Array<{ start: number; end: number; segment: ShortcodeSegment }> = []

  let m: RegExpExecArray | null
  const re = new RegExp(STANDALONE_PATTERN.source, 'g')
  while ((m = re.exec(text)) !== null) {
    matches.push({
      start: m.index,
      end: m.index + m[0].length,
      segment: { type: 'standalone-quote', quote: m[1], author: m[2] },
    })
  }

  let pos = 0
  while (pos < text.length) {
    const openMatch = text.slice(pos).match(FONT_OPEN_PATTERN)
    if (!openMatch) break
    const openStart = pos + (openMatch.index ?? 0)
    const openEnd = openStart + openMatch[0].length
    const closeTag = '{{< /font >}}'
    const closeIdx = text.indexOf(closeTag, openEnd)
    if (closeIdx === -1) break
    const content = text.slice(openEnd, closeIdx).trim()
    matches.push({
      start: openStart,
      end: closeIdx + closeTag.length,
      segment: { type: 'font', size: openMatch[1], weight: openMatch[2], content },
    })
    pos = closeIdx + closeTag.length
  }

  matches.sort((a, b) => a.start - b.start)
  return matches
}

export function parseShortcodes(body: string): ShortcodeSegment[] {
  const matches = findAllMatches(body)
  const segments: ShortcodeSegment[] = []
  let lastEnd = 0

  for (const { start, end, segment } of matches) {
    let before = body.slice(lastEnd, start)
    before = before.replace(/\n*> *$/, '')
    if (before.trim()) {
      segments.push({ type: 'markdown', content: before })
    }
    segments.push(segment)
    lastEnd = end
  }

  const tail = body.slice(lastEnd)
  if (tail) {
    segments.push({ type: 'markdown', content: tail })
  }

  return segments.length > 0 ? segments : [{ type: 'markdown', content: body }]
}
